import MomentUtils from "@date-io/moment";
import { jssPreset, StylesProvider, ThemeProvider } from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import React from "react";
import useSettings from "src/hooks/useSettings";
import { createTheme } from "src/theme";
import { create } from 'jss';
import rtl from 'jss-rtl';

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

export const WaypointMaterialUIProvider = ({ children }) => {
	const { settings } = useSettings();
	return (
		<ThemeProvider theme={createTheme(settings)}>
			<StylesProvider jss={jss}>
				<MuiPickersUtilsProvider utils={MomentUtils}>
					{children}
				</MuiPickersUtilsProvider>
			</StylesProvider>
		</ThemeProvider>
	);
};
